<template>
  <div class="plan-subtitle">
    <div class="plan-subtitle__wraper">
      <div v-html="subtitle.text" :style="{ color: subtitle.color }"></div>
      <NotificationIcon
        v-if="tooltip"
        class="plan-subtitle__info-icon"
        :style="{ stroke: subtitle.color }"
        v-tooltip="{
          content: `${tooltip}`,
          placement: 'top',
          classes: ['tooltip__text-centered'],
        }"
      />
    </div>
    <FeatureUnderline v-if="displayUnderline" class="plan-subtitle__feature-underline" />
  </div>
</template>

<script>
import NotificationIcon from '@/assets/icons/notification.svg'
import FeatureUnderline from '@/assets/icons/plans/feature_underline.svg'

export default {
  name: 'PlanRowItemSubtitle',
  components: {
    NotificationIcon,
    FeatureUnderline,
  },
  props: {
    subtitle: {
      type: Object,
      required: true,
    },
    tooltip: {
      type: String,
      default: '',
    },
    displayUnderline: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
}
</script>

<style scoped lang="scss">
.plan-subtitle {
  width: 100%;
  display: grid;
  justify-content: center;
  &__wraper {
    display: flex;
    gap: 5px;
    justify-items: center;
    align-items: center;
    font-family: var(--font-regular);
    font-size: 14px;
    color: var(--white);
    text-align: center;
  }
  &--small {
    font-size: 16px;
  }
  &__info-icon {
    width: 16px;
  }
  &__feature-underline {
    justify-self: end;
    margin-right: 22px;
  }
}
</style>
